import apiClient from './authService';

export const paymentService = {
  // ── Invoices ──────────────────────────────────────────────────────────────
  getInvoiceSummary: () =>
    apiClient.get('/api/invoices/summary').then(r => r.data),

  getMyInvoices: () =>
    apiClient.get('/api/invoices/me').then(r => r.data),

  getTenantInvoices: (tenantId) =>
    apiClient.get(`/api/invoices/tenant/${tenantId}`).then(r => r.data),

  getInvoices: (filters = {}) =>
    apiClient.get('/api/invoices', { params: filters }).then(r => r.data),

  createInvoice: (data) =>
    apiClient.post('/api/invoices', data).then(r => r.data),

  voidInvoice: (id) =>
    apiClient.post(`/api/invoices/${id}/void`).then(r => r.data),

  payInvoice: (id) =>
    apiClient.post(`/api/invoices/${id}/pay`).then(r => r.data),

  // ── Payments / Ledger ─────────────────────────────────────────────────────
  getMyLedger: () =>
    apiClient.get('/api/payments/ledger/me').then(r => r.data),

  getTenantLedger: (tenantId) =>
    apiClient.get(`/api/payments/ledger/tenant/${tenantId}`).then(r => r.data),

  getTenantBalance: (tenantId) =>
    apiClient.get(`/api/payments/tenant/${tenantId}/balance`).then(r => r.data),

  getPayments: (filters = {}) =>
    apiClient.get('/api/payments', { params: filters }).then(r => r.data),

  recordPayment: (data) =>
    apiClient.post('/api/payments', data).then(r => r.data),

  voidPayment: (id) =>
    apiClient.delete(`/api/payments/${id}`).then(r => r.data),

  // ── ACH — Connect onboarding (Landlord) ───────────────────────────────────
  startConnectOnboarding: () =>
    apiClient.post('/api/ach/connect/onboard').then(r => r.data),

  getConnectStatus: () =>
    apiClient.get('/api/ach/connect/status').then(r => r.data),

  getConnectLoginLink: () =>
    apiClient.post('/api/ach/connect/login-link').then(r => r.data),

  getConnectBankAccount: () =>
    apiClient.get('/api/ach/connect/bank-account').then(r => r.data),

  saveConnectBankAccount: (data) =>
    apiClient.post('/api/ach/connect/bank-account', data).then(r => r.data),

  setupBankAccount: (data) =>
    apiClient.post('/api/ach/setup-bank', data).then(r => r.data),

  // ── ACH — Bank setup (Tenant) ─────────────────────────────────────────────
  createSetupIntent: () =>
    apiClient.post('/api/ach/setup-intent').then(r => r.data),

  completeSetup: (paymentMethodId) =>
    apiClient.post('/api/ach/setup-complete', { paymentMethodId }).then(r => r.data),

  updatePaymentMethod: (paymentMethodId) =>
    apiClient.post('/api/ach/update-payment-method', { paymentMethodId }).then(r => r.data),

  getMyAchStatus: () =>
    apiClient.get('/api/ach/status/me').then(r => r.data),

  // ── ACH — Activation (Landlord) ───────────────────────────────────────────
  activateACH: (tenantId, paymentDay) =>
    apiClient.post('/api/ach/activate', { tenantId, paymentDay }).then(r => r.data),

  deactivateACH: (tenantId) =>
    apiClient.post('/api/ach/deactivate', { tenantId }).then(r => r.data),

  getAchStatus: (tenantId) =>
    apiClient.get(`/api/ach/status/${tenantId}`).then(r => r.data),
};
